import type { LinearIssueStatus } from '../../lib/types'
import { StatusBadge } from '@perch/ui'

const variantMap: Record<LinearIssueStatus, 'info' | 'watching' | 'stable'> = {
  open: 'info',
  in_progress: 'info',
  done: 'watching',
  cancelled: 'stable',
}

const labels: Record<LinearIssueStatus, string> = {
  open: 'Open',
  in_progress: 'In Progress',
  done: 'Done',
  cancelled: 'Cancelled',
}

export function LinearStatusBadge({ issue }: { issue: { status: LinearIssueStatus; linear_issue_url: string; linear_issue_number: number | null } }) {
  return (
    <a
      href={issue.linear_issue_url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="hover:opacity-80 transition-opacity"
    >
      <StatusBadge variant={variantMap[issue.status]}>
        <svg className="w-3 h-3" viewBox="0 0 100 100" fill="currentColor">
          <path d="M20.73 79.27C9.07 67.61 9.07 48.94 20.73 37.28L37.28 20.73C48.94 9.07 67.61 9.07 79.27 20.73C90.93 32.39 90.93 51.06 79.27 62.72L62.72 79.27C51.06 90.93 32.39 90.93 20.73 79.27ZM28.8 71.2C36.98 79.38 50.06 79.38 58.24 71.2L71.2 58.24C79.38 50.06 79.38 36.98 71.2 28.8C63.02 20.62 49.94 20.62 41.76 28.8L28.8 41.76C20.62 49.94 20.62 63.02 28.8 71.2Z" />
        </svg>
        {issue.linear_issue_number ? `#${issue.linear_issue_number}` : labels[issue.status]}
      </StatusBadge>
    </a>
  )
}
